import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

import { Notification, Configuration } from './models/notificacion';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Procurator } from './models/procurator';


@Injectable()
export class NotificationService {

    searchText = '';
    notifications: Notification[];
    actions: any;


    onNotificationsChanged: BehaviorSubject<any>;
    currentNotification: Notification;
    onCurrentNotificationChanged: BehaviorSubject<any>;
    onSearchTextChanged: BehaviorSubject<any>;
    routeParams: any;

    pageReceived: any;
    onPageReceivedChanged: BehaviorSubject<any>;
    pageSent: any;
    onPageSentChanged: BehaviorSubject<any>;

    configuration: Configuration;
    onConfigurationChanged: BehaviorSubject<any>;

    constructor(private http: HttpClient) {
      this.onCurrentNotificationChanged = new BehaviorSubject(undefined);
      this.onNotificationsChanged = new BehaviorSubject([]);
      this.onSearchTextChanged = new BehaviorSubject('');

      this.pageReceived = {
        pageNumber: 0,
        size: 10,
        search_term: ''
      };
      this.onPageReceivedChanged = new BehaviorSubject(this.pageReceived);

      this.pageSent = {
        pageNumber: 0,
        size: 10,
        search_term: ''
      };
      this.onPageSentChanged = new BehaviorSubject(this.pageSent);

      this.configuration = {
        id_user: null,
        event_config: [],
        methods: {},
        show_config: false
      };
      this.onConfigurationChanged = new BehaviorSubject(this.configuration);
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
      this.routeParams = route.params;

      if (this.routeParams.folderHandle === 'config') {
        return new Promise((resolve, reject) => {
          Promise.all([
            this.getConfiguration()
          ]).then(
            () => {
              this.notifications = [];
              this.setCurrentNotification(null);
              resolve(resolve);
            }
          );
        });
      } else {
        return new Promise((resolve, reject) => {
          Promise.all([
            this.getNotifications()
          ]).then(
            () => {
              if ( this.routeParams.notificationId ) {
                this.setCurrentNotification(this.routeParams.notificationId);
              } else {
                this.setCurrentNotification(null);
              }

              this.onSearchTextChanged.subscribe(searchText => {
                this.searchText = searchText;
                this.pageReceived.filter = searchText;
                this.pageSent.filter = searchText;
                this.pageReceived.pageNumber = 0;
                this.pageSent.pageNumber = 0;
                this.getNotifications();
              });

              resolve(resolve);
            },
            reject
          );
        });
      }
    }

    getConfiguration(): Promise<Configuration> {
      return this.getUserConfiguration();
    }

    getNotifications(): Promise<Notification[]> {
      return this.getNotificationByFolders(this.routeParams.folderHandle);
    }

    getUserConfiguration(): Promise<Configuration> {
      return new Promise((resolve, reject) => {
        this.http.get<any>(`${environment.BACKEND}notificacion/conf`)
        .subscribe(data => {
          this.configuration = data.response;
          this.configuration.show_config = true;
          this.onConfigurationChanged.next(this.configuration);
          resolve(undefined);
        }, error => {
        reject();
        });
      });
    }

    getNotificationByFolders(handle): Promise<Notification[]> {
      return new Promise((resolve, reject) => {
        if (handle === 'recibido') {
          const httpParams = new HttpParams({
            fromObject: this.pageReceived
          });
          this.http.get<any>(`${environment.BACKEND}notificacion/searchlist`, {params: httpParams})
          .subscribe(data => {
            this.notifications = data.response.data;
            this.pageReceived = data.response.page;
            this.onNotificationsChanged.next(this.notifications);
            this.onPageReceivedChanged.next(this.pageReceived);
            this.actions = data.actions;
            
            resolve(this.notifications);
          }, reject);
        }
        if (handle === 'enviado') {
          const httpParams = new HttpParams({
            fromObject: this.pageSent
          });
          this.http.get<any>(`${environment.BACKEND}notificacion/sentsearch`, {params: httpParams})
          .subscribe(data => {
            this.notifications = data.response.data;
            this.pageSent = data.response.page;
            this.onNotificationsChanged.next(this.notifications);
            this.onPageSentChanged.next(this.pageSent);
            resolve(this.notifications);
          }, reject);
        }
      });
    }

    getActions() {
      return this.actions;
    }

    createNotification(value) {
      return this.http.post(`${environment.BACKEND}notificacion/guardar_mensaje`, value);
    }

    markAsView(value) {
      return this.http.post(`${environment.BACKEND}notificacion/viewed`, value);
    }

    countUnRead() {
      return this.http.get(`${environment.BACKEND}notificacion/count`);
    }

    setCurrentNotification(id): void {
      this.currentNotification = this.notifications.find(notification => {
        return notification.ID === id || notification.ID_BODY === id;
      });

      this.onCurrentNotificationChanged.next(this.currentNotification);
    }

    getUsers(): Observable<Procurator[]> {
      return this.http.get<Procurator[]>(`${environment.BACKEND}notificacion/users`);
    }

    setPage(page) {
      let obj = {};
      this.routeParams.folderHandle === 'recibido' ?
        this.pageReceived.pageNumber = page.pageNumber :
        this.pageSent.pageNumber = page.pageNumber;
      this.getNotifications().then(obj = this.getPage());
      return obj;
    }

    getPage() {
      let obj;
      this.routeParams.folderHandle === 'recibido' ? obj = this.pageReceived : obj = this.pageSent;
      obj = {
        size: parseInt(obj.size, 10),
        totalElements: parseInt(obj.totalElements, 10),
        totalPages: parseInt(obj.totalPages, 10),
        pageNumber: parseInt(obj.pageNumber, 10)
      };
      return obj;
    }

    updateNotificationConfiguration(config) {
      this.configuration = config;
      this.onConfigurationChanged.next(this.configuration);
      return this.http.put(`${environment.BACKEND}notificacion/confupdate`, config);
    }

}
